export const settingsPageButtonLabel = "Mp2Q_d";
export default {settingsPageButtonLabel};